/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as SignatureDefs from './defs.defs.js'

const $nsid = 'tools.ozone.signature.findCorrelation'

export { $nsid }

export const $params = /*#__PURE__*/ l.params({
  dids: /*#__PURE__*/ l.array(/*#__PURE__*/ l.string({ format: 'did' })),
})

export type $Params = l.InferOutput<typeof $params>

export const $output = /*#__PURE__*/ l.jsonPayload({
  details: /*#__PURE__*/ l.array(
    /*#__PURE__*/ l.ref<SignatureDefs.SigDetail>(
      (() => SignatureDefs.sigDetail) as any,
    ),
  ),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Find all correlated threat signatures between 2 or more accounts. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output)

export { main }

export const $lxm = $nsid
